import { mergeProps as _mergeProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, {
    class: "define-term-tooltip",
    modelValue: _ctx.tooltip,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tooltip) = $event)),
    width: _ctx.width,
    "open-on-click": !_ctx.noClick,
    "open-on-hover": true,
    "open-on-focus": true,
    "location-strategy": "connected",
    location: "bottom center",
    origin: "top center",
    offset: "-2",
    "content-class": "top-triangle"
  }, {
    activator: _withCtx(({props}) => [
      _renderSlot(_ctx.$slots, "term", _mergeProps(props, {
        tabindex: "0",
        props: props
      }), () => [
        _createElementVNode("span", _mergeProps({
          tabindex: "0",
          class: ['define-term-tooltip', _ctx.inline ? 'inline' : '', _ctx.bold ? 'define-term-bold' : '', _ctx.underlined ? 'define-term-underline' : '' ]
        }, props), _toDisplayString(_ctx.term), 17)
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "definition", {}, () => [
        _createElementVNode("div", {
          class: "define-term-tooltip definition",
          innerHTML: _ctx.definition
        }, null, 8, _hoisted_1)
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "width", "open-on-click"]))
}